<template>
  <div class="module-table">
    <el-table :data="paginatedData" border size="small" class="data-table">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="分支机构名称" >
            <template slot-scope="scope">
              {{ scope.row.branch_institution_name || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="负责人姓名">
            <template slot-scope="scope">
              {{ scope.row.leader_name|| '-' }}
            </template>
        </el-table-column>
        <el-table-column label="注册号">
            <template slot-scope="scope">
              {{ scope.row.register_number|| '-' }}
            </template>
        </el-table-column>
        
        <el-table-column label="统一社会信用代码">
            <template slot-scope="scope">
              {{ scope.row.usc_code|| '-' }}
            </template>
        </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, prev, pager, next, jumper"
      :total="moduleData.length"
      style="margin-top: 10px; text-align: right;"
    />
  </div>
</template>

<script>
export default {
    name: 'branchList',
  computed: {
    paginatedData() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.moduleData.slice(start, start + this.pageSize);
    }
  },
    data() {
        return {
            currentPage: 1,
            pageSize: 10,
            title: '分支机构',
        }
    },  
    props: {
        moduleData: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        handleCurrentChange(val) {
            this.currentPage = val;
        },
    }
}
</script>

<style scoped lang="scss">
// 表格铺满
.module-table {
  width: 100%;
  .el-table { 
    width: 100%;
  }
}
</style>